import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useUserContext from 'Context/UserContext';
import useLoginToken from './Hooks/useLoginToken';
import OnboardingHasUser from './OnboardingHasUser';
import OnboardingTokenExpired from './Pages/OnboardingTokenExpired';

const styles = () => ({
  root: {},
});

const OnboardingContainer = ({
  classes,
  className,
}) => {
  const { checkPlanningAgreementToken } = useSwaggerlessContext();
  const { userResource } = useUserContext();
  const { isLoggingIn, error } = useLoginToken({
    api: {
      checkPlanningAgreementToken, // Kill this with fire as soon as possible
    },
  });

  if (error) {
    return (
      <OnboardingTokenExpired />
    );
  }

  return (
    <FullScreenDataContainer
      className={classNames(classes.root, className)}
      component={OnboardingHasUser}
      loading={!userResource || isLoggingIn}
    />
  );
};

OnboardingContainer.defaultProps = {
  className: '',
};

OnboardingContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingContainer);
